import React, { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import { ENDPOINT, Routes } from "../../../constants";
import { CreateAccountCredentials } from "../../../types";
import TextField from "../../../components/TextField";
import Button from "../../../components/Button";
import SignupImg from "../../../assets/images/signup.png"
import './index.css'
import { FetchApi } from "../../../api/fetch";

const CreateAccount = React.memo(() => {
  const history = useHistory();


  const goToLogin = useCallback(() => {
    history.push(Routes.LOGIN);
  }, [history]);

  const onFinish = useCallback(() => {
    history.push(Routes.VERIFY_EMAIL);
  }, [history]);

  const onCreateAccount = async (createAccountCredentials: CreateAccountCredentials, actions: any) => {
    try {
       await FetchApi({
        endpoint:`${ENDPOINT.BASE_AUTH}/signup`, 
        method: "POST",
        body:  (createAccountCredentials),
      })
      sessionStorage.setItem("loggedUser", createAccountCredentials.email)
      onFinish()
    } catch (error: any) {
      actions.setSubmitting(false);
    }
  }


  return (
    <div className="flex items-start acct">
      <div className="acct-left">
        <img src={SignupImg} alt="signup" />
      </div>
      <div className="flex items-center mx-auto  acct-right relative" >
        <div className="flex-col w-full mx-auto px-2 mt-8 sm:px-6 lg:px-4 lg:mt-16">
          <div className="md:shadow-lg md:p-8 flex-col items-center">
            <h1 className="text-3xl  text-center mb-3 font-medium">CREATE AN ACCOUNT</h1>
            <p className="mb-12 text-sm w-full font-light text-center">
              Create an account below to manage your collection(s).
            </p>
            <Formik
              validateOnBlur={false}
              initialValues={{
                email: "",
                password: "",
                error: "",
              }}
              validationSchema={Yup.object().shape({
                email: Yup.string()
                  .trim()
                  .required("Please enter your email address.")
                  .email("Must be a valid email."),
                password: Yup.string().required("Please enter your password."),
              })}
              onSubmit={({ error, email, password }, actions) => {
                onCreateAccount({ email, password }, actions)

              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  noValidate
                  className="max-w-lg mx-auto flex flex-col items-center"
                >
                  <ErrorMessage name="error" />
                  <TextField
                    type="email"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    showError={touched.email && Boolean(errors.email)}
                    required
                    id="email"
                    name="email"
                    autoComplete="email"
                    placeholder="example@mail.com"
                    label="Email"
                  />
                  <TextField
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    showError={touched.password && Boolean(errors.password)}
                    required
                    name="password"
                    placeholder="Min 8 characters"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    label="Password"
                  />
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    className="w-full btn bg-gradient text-kyzzen-primary font-medium"
                  >
                    CREATE ACCOUNT
                  </Button>
                  <Button
                    type="button"
                    className="mb-6 w-full text-center text-sm text-gray-100 hover:text-gray-500 absolute bottom-0"
                    disabled={isSubmitting}
                    onClick={goToLogin}
                  >
                    Already have an account? <span className="gradient-text"> Sign In</span>
                  </Button>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>

    </div>
  );
});

export default CreateAccount;